
export default class Products {

    static getUrl(product, option = null) {
        if (option !== null) {
            return `/${product.slug}.html#optionId=${option.id}`;
        }

        return `/${product.slug}.html`;
    }

    static createUrl(slug, optionId = null) {
        if (optionId !== null) {
            return `/${slug}.html#optionId=${optionId}`;
        }

        return `/${slug}.html`;
    }

    static getSalePrice(product, promotion) {
        if (!promotion) {
            return product.price;
        }

        return product.price * (1 - promotion.discount_percentage / 100);
    }
}
